export enum AppTheme {
	Dark = 'DARK',
	Light = 'LIGHT',
}
